import { json } from 'helpers/data';
import React from 'react';
import ServerImage from 'components/server-image/server-image';
import { Link } from 'react-router-dom';

interface Props {
    name: string;
    priceLevel: string;
    logo: string,
    versionSubscriptionId:number
}

function Product({name, versionSubscriptionId,priceLevel,logo}: Props) {
    return (
        <Link to={`/my-apps/${versionSubscriptionId}/licenses?device`} className='productName'>
            <div className='product-color'>
            <ServerImage className={"logo"} src={logo} />

            </div>
            <div className='info'>
                <h3>{json(name)}</h3>
                <p>{priceLevel}</p>
            </div>
        </Link>
    );
}

export default Product;